import React from "react";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <header className="section-header">
          <h2>{t("about.sectionTitle")}</h2>
        </header>

        <div className="about-content">
          <div className="about-text about-box">
            <p className="section-subtitle">{t("about.sectionSubtitle")}</p>
            <p>{t("about.intro")}</p>
            <p>{t("about.focus")}</p>
            <p>{t("about.experiences")}</p>
            <p>{t("about.philosophy")}</p>
            <p>{t("about.description")}</p>
            <p>{t("about.programs")}</p>
          </div>

          <div className="about-mission">
            <h3>{t("about.missionTitle")}</h3>
            <p>{t("about.mission")}</p>
          </div>

          <div className="about-vision">
            <h3>{t("about.visionTitle")}</h3>
            <p>{t("about.vision")}</p>
          </div>

          <div className="about-founder">
            <h3>{t("about.founderTitle")}</h3>
            <p>{t("about.founder")}</p>
            <p>{t("about.valladolid")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

